var map = {
	"./1.jpg": "fURY",
	"./2.png": "OHzJ",
	"./3.png": "JeSn",
	"./4.png": "EnwO",
	"./5.png": "kM2N",
	"./6.jpg": "HP+p"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6pVj";